"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    style: style,
    width: "12",
    height: "17",
    viewBox: "0 0 12 17"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M0,0.999960201 C0,0.447697432 0.455760956,0 1.00247329,0 L10.9975267,0 C11.5511774,0 12,0.454708934 12,0.999960201 L12,16.0000398 C12,16.5523026 11.544239,17 10.9975267,17 L1.00247329,17 C0.448822582,17 0,16.5452911 0,16.0000398 L0,0.999960201 Z M2,2 L2,13 L10,13 L10,2 L2,2 Z M6,16 C6.55228475,16 7,15.5522847 7,15 C7,14.4477153 6.55228475,14 6,14 C5.44771525,14 5,14.4477153 5,15 C5,15.5522847 5.44771525,16 6,16 Z"
  }));
};

exports["default"] = _default;